import Button from "../../../shared/button";
import HotelDetails from "./HotelDetails";
import { useGetHotelListQuery } from "../../../store/customer-experience/customerExperienceApi";
import { useGetCurrentUserQuery } from "../../../store/user/userApi";

const ManageHotels = ({
	setActive
}: {
	setActive: (active: "profile" | "hotels" | "add-hotel") => void
}) => {
  const { data: user } = useGetCurrentUserQuery();
  const { data: hotelList } = useGetHotelListQuery(user?.id || "", {
    skip: !user?.id,
  });
  const handleNavigateAddProfile = () => setActive('add-hotel');
  return (
    <div>
      <div className="py-5 border-b">
        <>
          <div className="flex flex-row">
            <Button
              type="button"
			  onClickButton={handleNavigateAddProfile}
              className="flex flex-row items-center justify-center text-saloon-btn bg-white py-2 px-6 rounded-lg text-sm h-10 min-w-80"
              icon={
                <img
                  alt="settings"
                  className="mr-2 w-4"
                  src="/assets/shared/reviewt.svg"
                />
              }
              label="+ Add another hotel to your franchise"
            />
          </div>
        </>
      </div>
      <div className="flex flex-wrap -mx-2 mt-5">
        {hotelList?.map((hotel) => (
          <HotelDetails
            hotelName={hotel.hotelName}
            locationCode={hotel.locationCode}
            timezone={hotel.timezone}
            address={hotel.address.addressLine1}
            description={hotel.description}
          />
        ))}
      </div>
    </div>
  );
};

export default ManageHotels;
